module.exports = __webpack_public_path__ + "static/img/1.0048b4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/mark-paper/1.png
// module id = e718
// module chunks = 0